<template>
  <v-layout row justify-end>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('AdministrationEditUserDetailDialog.editTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="clearForm()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form v-model="valid" ref="form" lazy-validation style="width: 100%">
          <v-card-text>
            <v-layout pa-5>
              <v-flex xs12>
                <v-text-field label="Email" v-model="editUserData.Email" :rules="emailRules"></v-text-field>
                <v-autocomplete label="Tenant" v-model="editUserData.UserRole" :items="activeTenantNames" :rules="[v => !!v || 'Tenant is required']" required></v-autocomplete>
                <v-checkbox v-model="editUserData.IsSysAdmin" :label="'Is System Administrator'"></v-checkbox>
                <v-checkbox v-model="editUserData.IsTenantAdmin" :label="'Is Tenant Administrator'"></v-checkbox>
                <v-switch v-model="editUserData.EnableTwoFactor" :label="'Enable Two factor authentication'"></v-switch>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="submit()" :disabled="saveDisable">
              <v-icon class="mr-1">done</v-icon>
              {{ $t('Button.Save') }}
            </v-btn>
            <v-btn color="secondary" outline @click="clearForm()">{{ $t('Button.Close') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-card color="grey lighten-4">
      <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-layout>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const admin = createNamespacedHelpers('admin')
  const authenticate = createNamespacedHelpers('authenticate')
  import AuthenticationUtil from '@/components/mixins/AuthenticationUtil'
  export default {
    mixins: [AuthenticationUtil],
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      userDetail: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        dialog: '',
        snackbar: '',
        snackColor: '',
        snackMessage: '',
        valid: true,

        editUserData: {},
        email: '',
        userRole: null,

        emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
        ],
      }
    },
    mounted() {
      if (!this.roleList || !this.roleList.length) {
        this.getRoleList()
      }
    },
    computed: {
      ...admin.mapGetters(['roleList']),
      ...authenticate.mapGetters({ currentUserName: 'username' }),
      activeTenantNames() {
        return this.roleList.filter(tenant => !tenant.IsArchived).map(tenant => tenant.RoleName)
      },
      saveDisable() {
        if (this.editUserData.UserRole == this.userDetail.UserRole &&
          this.editUserData.Email == this.userDetail.Email &&
          this.editUserData.IsSysAdmin == this.userDetail.IsSysAdmin &&
          this.editUserData.IsTenantAdmin == this.userDetail.IsTenantAdmin &&
          this.editUserData.EnableTwoFactor == this.userDetail.EnableTwoFactor) {
          return true
        } else {
          return false
        }

      },
    },
    watch: {
      show() {
        this.dialog = true
        this.editUserData = JSON.parse(JSON.stringify(this.userDetail))
      },
    },
    methods: {
      ...admin.mapActions(['getRoleList', 'postEditUserDetail']),
      ...authenticate.mapActions(['updateCurrentUserInfo']),
      submit() {
        if (this.$refs.form.validate()) {
          var dataToUpdate = {
            UserName: this.editUserData.UserName,
            NewRole: this.editUserData.UserRole,
            Email: this.editUserData.Email,
            EnableTwoFactor: this.editUserData.EnableTwoFactor,
            IsSysAdmin: this.editUserData.IsSysAdmin,
            IsTenantAdmin: this.editUserData.IsTenantAdmin,
            NewRoleId: this.roleList.find(x => x.RoleName == this.editUserData.UserRole).Id,
          }
          let options = {
            data: dataToUpdate,
            successCb: () => {
              this.snackMessage = this.$t('AdministrationEditUserDetailDialog.updateSuccessMsg')
              this.snackColor = 'success'
              this.snackbar = true
              this.clearForm()
              if (this.areSameName(this.editUserData.UserName, this.currentUserName)) {
                console.log('same')
                this.updateCurrentUserInfo(dataToUpdate)
              }
            },
            failedCb: (err) => {
              this.snackColor = 'error'
              this.snackMessage = err
              this.snackbar = true
            },
          }
          this.postEditUserDetail(options)
        }
      },
      clearForm() {
        this.$refs.form.reset()
        this.dialog = false
      },
    },
  }
</script>